/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";

import {
  addReimbursementTxnLabel,
  reimbursementTxnApproval,
  reimbursementTxnViewAll,
  removeReimbursementTxnLabel,
  resetSpecificDetail,
  resetToggle,
  setToggleRemTxn,
} from "../../../../redux/features/reimbursementTransaction";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

// Component Imports
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer";
import ListDualText from "../../../../components/_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import Loader from "../../../../components/Loader/Index";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";

// Utils Imports
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import useCategories from "../../../../utils/useCategories";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";

import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { ReimburseViewAll } from "../../../../redux/features/accounts/ReimburseAccount";
import useMultiSelect from "../../../../utils/useMultiSelect";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const ReimbursementTransactionsViewAll = (props) => {
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const pageSizeChangedRef = useRef(false);
  const navStateAppliedRef = useRef(false);
  const lifecycleSyncedToUrlRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const { startDateLocationState, endDateLocationState } = location.state || {};

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);
  const categories = useSelector(
    (state) => state?.sharedResources.categoriesData?.categories,
  );
  const categoryMapper = useCategories();
  // Pagination
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state && location?.state?.approvalStatus
      ? {
          lifecycle: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        },
  );

  const isPopup = props.type === "reimburse_txnViewAll_popup";
  const isSimilar = props.similarTxnType === "similarTxn";
  const lockedOwner = isSimilar && !!props.queryParams?.owner_account_id;
  const lockedAccount =
    isPopup ||
    !!props.TxnHistoryid ||
    (isSimilar && !!props.queryParams?.beneficiary_account_id);
  const lockedCategory = !!props.categoryName;
  const lockedLabels = props.flow === "txnLabelfilterhistory";
  const lockedAmount = isSimilar && !!props.queryParams?.amount;
  const lockedPayment = isSimilar && !!props.queryParams?.payment_method;
  const lockedStatus = props.flow === "reimburse_txnViewAll_popup_reject";

  const isEmbeddedPopup =
    props?.type === "reimburse_txnViewAll_popup" ||
    props?.similarTxnType === "similarTxn";

  // USESTATES
  const [pendingSearchParams, setPendingSearchParams] = useState(null);
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    Number(searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne),
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [mainData, setMainData] = useState([]);
  const [displayCategory, setDisplayCategory] = useState(
    props?.type === "reimburse_txnViewAll_popup"
      ? props.popupCatName
      : searchParam.get("dispCat"),
  );

  // Label Popup
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [animateViewAll, setAnimateViewAll] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false); // Isolated loading state

  const [dataLoading, setDataLoading] = useState(false);

  // Filters
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");

  // Top summary & label selection
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);

  // Owner account filter
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    props?.Owner_account_number ? props?.Owner_account_number : "",
  );
  const [ownerAccId, setOwnerAccId] = useState(
    props?.similarTxnType === "similarTxn" &&
      props?.queryParams?.owner_account_id
      ? props?.queryParams?.owner_account_id
      : searchParam.get("sourceAcc") || "",
  );

  // Category & label filters
  const [currentCategory, setCurrentCategory] = useState(
    props?.categoryName
      ? props?.categoryName
      : searchParam.get("category") || "",
  );
  const [labelSearchText, setLabelSearchText] = useState(
    props?.txnLabelfilter
      ? props?.txnLabelfilter
      : searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [labels, setLabels] = useState([]);

  // Amount & input helpers
  const [txnAmountFilter, setTxnAmountFilter] = useState(
    lockedAmount ? props.queryParams.amount : searchParam.get("amount") || "",
  );
  const [inputData, setInputData] = useState([]);

  const [, setCurrentStatusDistribution] = useState(
    searchParam.get("distribution") || "",
  );

  // Date range filters
  const rawDateParam = searchParam.get("date")?.split(",") || [];

  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState
      ? startDateLocationState
      : rawDateParam[0]
        ? Number(rawDateParam[0])
        : "",
  );

  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState
      ? endDateLocationState
      : rawDateParam[1]
        ? Number(rawDateParam[1])
        : "",
  );

  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    lockedPayment
      ? props.queryParams.payment_method
      : searchParam.get("paymentmethod") || "",
  );

  // Additional account-related filters
  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.similarTxnType === "similarTxn" &&
      props?.queryParams?.beneficiary_account_id
      ? props?.queryParams?.beneficiary_account_id
      : props?.TxnHistoryid
        ? props?.TxnHistoryid
        : searchParam.get("beneAcc") || "",
  );

  const [accountName, setAccountName] = useState(
    props?.TxnHistoryAccountName ? props?.TxnHistoryAccountName : "",
  );

  // Get the approval status passed from the dashboard or URL
  const initialApprovalStatus =
    location.state?.approvalStatus || searchParam.get("lifecycle") || "all";

  // Status filters (initialized from URL or location.state so filters persist on back)
  const [currentStatus, setCurrentStatus] = useState(
    initialApprovalStatus && initialApprovalStatus !== "all"
      ? initialApprovalStatus.toLowerCase()
      : props?.flow === "reimburse_txnViewAll_popup_reject"
        ? "pending"
        : searchParam.get("lifecycle") || "",
  );
  const [currentDistributionStatus, setCurrentDistributionStatus] = useState(
    searchParam.get("distribution") || "",
  );

  const [accumulatedData, setAccumulatedData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentAccountId, SetcurrentAccountId] = useState("");
  const [closeCard, setCloseCard] = useState(false);

  // SELECTORS
  const services = useSelector((state) => state.refreshToken.services);
  const { reimbursementTxnViewAllLoading, toggleReimTxn } = useSelector(
    (state) => state.reimbursementTransaction,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //FUNCTIONS
  const handleAction = async (isSilent) => {
    setAnimateViewAll(false);
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        if (!isSilent) setLoading(true);

        const responseApproval = await dispatch(
          reimbursementTxnApproval({
            page_no: currentPage,
            page_size: pageSize,
            category: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.transactions || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(
          responseApproval?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
        setLoading(false);
        if (
          pageSizeChangedRef.current &&
          newApprovalData?.length &&
          isLabelClicked
        ) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newApprovalData.map((t) => t.txn_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        if (!isSilent) setLoading(true);
        if (!isEmbeddedPopup) {
          dispatch(resetSpecificDetail());
        }
        let queryParams = {
          page_no: currentPage,
          page_item_count: pageSize,
        };

        if (currentDistributionStatus && currentDistributionStatus !== "all") {
          if (currentDistributionStatus === "complete") {
            queryParams.distribution_lifecycle_status = "distribution_complete";
          } else if (currentDistributionStatus === "initiated") {
            queryParams.distribution_lifecycle_status =
              "distribution_initiated";
          } else if (currentDistributionStatus === "pending") {
            queryParams.distribution_lifecycle_status = "distribution_pending";
          } else {
            queryParams.distribution_lifecycle_status =
              currentDistributionStatus;
          }
        }

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (currentDistributionStatus) {
          queryParams.distribution_lifecycle_status = currentDistributionStatus;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = ownerAccId;
        }

        if (selectedBeneAccId) {
          queryParams.beneficiary_account_id = selectedBeneAccId;
        }

        if (currentIfscCode) {
          queryParams.owner_account_ifsc_code = currentIfscCode;
        }

        if (currentCategory) {
          queryParams.category = currentCategory;
        }

        if (txnAmountFilter) {
          queryParams.amount = txnAmountFilter;
        }

        if (labelSearchText) {
          queryParams.labels = labelSearchText;
        }
        if (searchUserText !== "" && props?.seachType !== "rejectall") {
          queryParams.additional_data = searchUserText;
        }

        const response = await dispatch(reimbursementTxnViewAll(queryParams));
        setMainData(response?.payload);
        const newData = response?.payload?.transactions || [];
        setAccumulatedData(newData);
        setLabels((prev) => {
          const fromApi = response?.payload?.summary?.available_labels || [];
          return Array.from(new Set([...(prev || []), ...fromApi]));
        });
        setLoading(false);
        setTotalBalanceAmount(
          response?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
        // When page size was reduced and in label mode, trim selection to only IDs on current page
        if (pageSizeChangedRef.current && newData?.length && isLabelClicked) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newData.map((t) => t.txn_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(GlobalConfiguration?.lengthCheckZero);
      }
    }
  };

  const onMount = () => {
    dispatch(resetToggle());
  };

  // Batch the shared Clear all field setters into one URL update.
  const handleSubmit = (key, value) => {
    if (key !== "pageno" && key !== "pagesize") setLabelTransactions([]);
    if (!isPopup && !isSimilar) {
      setPendingSearchParams((previous) => ({ ...previous, [key]: value }));
    }
  };

  useEffect(() => {
    if (!pendingSearchParams) return;
    const params = new URLSearchParams(location.search);
    Object.entries(pendingSearchParams).forEach(([key, value]) => {
      if (value === "" || value == null) params.delete(key);
      else params.set(key, value);
    });
    params.set(
      "pageno",
      pendingSearchParams.pageno ?? GlobalConfiguration.lengthCheckOne,
    );
    params.set("pagesize", pendingSearchParams.pagesize ?? pageSize);
    const state = { ...location.state };
    if (pendingSearchParams.lifecycle === "") delete state.approvalStatus;
    if (pendingSearchParams.date === "") {
      delete state.startDateLocationState;
      delete state.endDateLocationState;
    }
    if (pendingSearchParams.distribution === "") {
      delete state.DistributionDashBoard;
      delete state.distribution_lifecycle_status;
    }
    navigate(
      { pathname: location.pathname, search: `?${params}` },
      { replace: true, state },
    );
    setPendingSearchParams(null);
  }, [pendingSearchParams, location, navigate, pageSize]);

  // Pagination

  const handlePagination = (page) => {
    if (props?.similarTxnType !== "similarTxn") handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleSelect = (value) => {
    if (Number(value) === Number(pageSize)) return;
    handleSubmit("pagesize", value);
    handleSubmit("pageno", GlobalConfiguration.lengthCheckOne);
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      labelTransactions?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(
        labelTransactions,
        setLabelTransactions,
        value,
        selectableTransactions,
      );
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setAccumulatedData([]);
    // toggleDropdown();
  };
  // Toggle

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }
    if (toggleReimTxn !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
      dispatch(setToggleRemTxn(newToggleValue));
    }
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const selectableTransactions = accumulatedData
    ?.filter((item) => item?.approval_status !== "archived")
    ?.map((item) => ({ ...item, id: item?.txn_id }));

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration?.intervalMedium,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      const s = displayDate(start);
      const e = displayDate(end);
      setStartDateFilter(s);
      setEndDateFilter(e);
      handleSubmit("date", `${s},${e}`);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      handleSubmit("date", "");
    }
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  // Label Popup

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);

      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      addReimbursementTxnLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addReimbursementTxnLabel.fulfilled.match(res)) {
      // 1. Optimistic UI patch
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );
      setAccumulatedData((prev) =>
        prev.map((acc) => {
          if (recordIds.includes(acc.txn_id)) {
            return {
              ...acc,
              labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
            };
          }
          return acc;
        }),
      );

      // 2. Silent background refresh
      handleAction(true);

      toast.dismiss();
      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addReimbursementTxnLabel.rejected.match(res)) {
      toast.dismiss();
      handleAction(true); // Re-sync in case of failure
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelPopupLoading(false);
    return addReimbursementTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      removeReimbursementTxnLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeReimbursementTxnLabel.fulfilled.match(res)) {
      // 1. Optimistic UI patch
      setAccumulatedData((prev) =>
        prev.map((acc) => {
          if (recordIds.includes(acc.txn_id)) {
            return {
              ...acc,
              labels: (acc.labels || []).filter(
                (l) => !labelsToUnassign.includes(l),
              ),
            };
          }
          return acc;
        }),
      );

      // 2. Silent background refresh
      handleAction(true);

      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeReimbursementTxnLabel.rejected.match(res)) {
      toast.dismiss();
      handleAction(true); // Re-sync in case of failure
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelPopupLoading(false);
    return removeReimbursementTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  // Label Select

  const handleSelectAll = () => {
    handleMultiSelectAll(
      labelTransactions,
      setLabelTransactions,
      selectedValue,
      selectableTransactions,
    );
  };

  const handleLabelTransactionSelect = (transaction) => {
    handleSingleSelect(labelTransactions, setLabelTransactions, selectedValue, {
      ...transaction,
      id: transaction?.txn_id,
    });
  };

  const handleTransactionClick = useCallback(
    (e, context) => {
      if (isLabelClicked) {
        const isAlreadySelected = labelTransactions.includes(context?.txn_id);
        if (isAlreadySelected) {
          setLabelTransactions((prev) =>
            prev.filter((id) => id !== context?.txn_id),
          );
        } else {
          setLabelTransactions((prev) => [...prev, context?.txn_id]);
        }
        return;
      }

      if (context?.txn_id) {
        if (isEmbeddedPopup) {
          SetcurrentAccountId(context?.txn_id);
          setCloseCard(true);
        } else {
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${context.txn_id}`,
            {
              replace: props?.HistoryPopup ? true : false,
              state: {
                isViewAll: location.pathname.includes("view_all"),
              },
            },
          );
          if (
            props.type === "reimburse_txnViewAll_popup" &&
            props.flow !== "reimburse_txnViewAll_popup_reject"
          ) {
            props.closeReimburseTxnDetailsModal();
          }
        }
      }
    },
    [
      navigate,
      location.pathname,
      isLabelClicked,
      labelTransactions,
      props.type,
      currentStatus,
      isEmbeddedPopup,
      props.closeReimburseTxnDetailsModal,
    ],
  );

  // Only editable fields enable the clear actions; history scope is retained.
  const hasSearchParameters = Boolean(
    searchUserText?.length ||
    // searchUserTextDebounce ||
    (!lockedOwner && ownerAccId) ||
    (!lockedAccount && selectedBeneAccId) ||
    (!lockedCategory && currentCategory) ||
    (!lockedLabels && labelSearchText?.length) ||
    (!lockedAmount && txnAmountFilter),
  );
  const hasFilterParameters = Boolean(
    startDateFilter ||
    endDateFilter ||
    currentDistributionStatus ||
    (!lockedStatus && currentStatus) ||
    (!lockedPayment && isPaymentMethod),
  );
  const clearParameterVisibility = hasSearchParameters || hasFilterParameters;

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setAnimateViewAll(false);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setLabelTransactions([]);
    setSearchUserTextDebounce("");
    setSearchUserText("");
    setActive("");
    setInputData([]);
    setaccountnumberstate("");
    setCurrentIfscCode("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentDistributionStatus("");
    if (!lockedOwner) {
      setOwnerAccId("");
      setAccountNumber("");
    }
    if (!lockedAccount) {
      setSelectedBeneAccId("");
      setAccountName("");
      setAccountNameValue("");
    }
    if (!lockedCategory) setCurrentCategory("");
    if (!lockedLabels) setLabelSearchText([]);
    if (!lockedAmount) setTxnAmountFilter("");
    if (!lockedPayment) setIsPaymentMethod("");
    if (!lockedStatus) setCurrentStatus("");
    if (!isPopup && !isSimilar) {
      setPendingSearchParams({
        search: "",
        date: "",
        distribution: "",
        ...(!lockedOwner && { sourceAcc: "" }),
        ...(!lockedAccount && { beneAcc: "" }),
        ...(!lockedCategory && { category: "" }),
        ...(!lockedLabels && { label: "" }),
        ...(!lockedAmount && { amount: "" }),
        ...(!lockedPayment && { paymentmethod: "" }),
        ...(!lockedStatus && { lifecycle: "" }),
      });
    }
  };

  // Status

  const statuses = [
    "approved",
    "require approval",
    "pending",
    "rejected",
    "abandoned",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasABeneficiary = services?.includes("AReimbursementTxn");

    const hasCBeneficiary = services?.includes("VReimbursementTxn");

    const beneficiaryTxn =
      hasCBeneficiary &&
      !hasABeneficiary &&
      !hasAdmin &&
      status === "require approval";

    const txnRequestTxn =
      hasABeneficiary && !hasCBeneficiary && !hasAdmin && status === "pending";

    if (beneficiaryTxn) {
      return false;
    }

    if (txnRequestTxn) {
      return false;
    }

    if (hasAdmin && hasABeneficiary && hasCBeneficiary) {
      return true;
    }

    return true;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  const handleDistributionChange = (selectedLabel) => {
    let statusToSend = "";
    switch (selectedLabel) {
      case "distribution created":
        statusToSend = "created";
        break;
      case "awaiting funds":
        statusToSend = "awaiting_funds";
        break;
      case "distribution initiated":
        statusToSend = "distribution_initiated";
        break;
      case "distribution rejected":
        statusToSend = "rejected";
        break;
      case "distribution complete":
        statusToSend = "distribution_complete";
        break;
      case "distribution abandoned":
        statusToSend = "abandoned";
        break;
      case "failed":
        statusToSend = "failed";
        break;
      default:
        break;
    }
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    handleSubmit("distribution", statusToSend);
    setCurrentDistributionStatus(statusToSend);
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "created":
        return "distribution created";
      case "awaiting_funds":
        return "awaiting funds";
      case "distribution_initiated":
        return "distribution initiated";
      case "rejected":
        return "distribution rejected";
      case "distribution_complete":
        return "distribution complete";
      case "abandoned":
        return "distribution abandoned";
      case "failed":
        return "failed";
      default:
        return "";
    }
  };

  const getDistributionColor = (distribution_lifecycle_status) => {
    switch (distribution_lifecycle_status) {
      case "created":
        return "var(--queued)";
      case "awaiting_funds":
        return "var(--queued)";
      case "distribution_initiated":
        return "var(--queued)";
      case "distribution_complete":
        return "var(--settled)";
      case "abandoned":
        return "var(--abandoned)";
      case "failed":
        return "var(--queued)";
      default:
        return "var(--text-primary)";
    }
  };

  // USEEFFECT HOOKS

  useEffect(() => {
    if (location.state?.DistributionDashBoard) {
      setCurrentStatus("all");
      setCurrentDistributionStatus(
        location.state?.distribution_lifecycle_status || "all",
      );
    }
  }, [
    location.state?.DistributionDashBoard,
    location.state?.distribution_lifecycle_status,
  ]);

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  // Redirect

  useEffect(() => {
    // Apply navigation state only once
    if (location.state?.DistributionDashBoard && !navStateAppliedRef.current) {
      setCurrentStatus("all");
      setCurrentStatusDistribution(
        location.state.distribution_lifecycle_status || "all",
      );
      setStartDateFilter(location.state.startDateLocationState || "");
      setEndDateFilter(location.state.endDateLocationState || "");

      navStateAppliedRef.current = true;
      return;
    }

    (scrollContainerRef?.current ?? window).scrollTop = 0;
    handleAction().finally((x) => {
      (scrollContainerRef?.current ?? window).scrollTop = 0;

      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
    });
  }, [
    dispatch,
    markerData,
    currentPage,
    searchUserText,
    isPaymentMethod,
    pageSize,
    ownerAccId,
    accountnumberstate,
    selectedBeneAccId,
    currentStatus,
    currentDistributionStatus,
    startDateFilter,
    endDateFilter,
    currentIfscCode,
    currentCategory,
    txnAmountFilter,
    labelSearchText,
  ]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    if (isPopup || isSimilar || lifecycleSyncedToUrlRef.current) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState && statusFromState !== "all") {
      const valueToSync = statusFromState.toLowerCase?.() ?? statusFromState;
      handleSearchParams("lifecycle", valueToSync);
      lifecycleSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, props.type, handleSearchParams]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    let response;
    let data;
    setDataLoading(true);
    (async () => {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data = response?.payload?.categories?.map((itm) => {
            return {
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            };
          });
          setInputData(data);
          setDataLoading(false);
          break;

        case "Owner account":
          setInputData([]);
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          break;

        case "Reimbursement account":
          setInputData([]);
          response = await dispatch(
            ReimburseViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.reimbursement_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          break;

        case "Search":
          setSearchUserText(searchUserTextDebounce);
          setDataLoading(false);
          break;

        case "Labels":
          data = labels
            ?.filter((itm) => {
              if (itm.includes(searchUserTextDebounce)) return true;
              else return false;
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;
        default:
          break;
      }
      setDataLoading(false);
    })();
  }, [active]);

  return (
    <>
      <div
        className={`overflow-hidden bg-primary-bg ${(props.type === "reimburse_txnViewAll_popup" || props?.similarTxnType === "similarTxn") && "h-full"} relative flex flex-col`}
      >
        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              labelTransactions={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelTransactions}
              onClose={handleClose}
              loading={labelPopupLoading}
              setLoading={setLabelPopupLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}

        {closeCard && (
          <div className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="emphasis"
              textSize="font-lg"
              subtext={"Leaving this page will exit from the current flow."}
              btnOneText="Stay"
              btnOneHandleFunction={() => setCloseCard(false)}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoHandleFunction={() => {
                setCloseCard(false);

                navigate(
                  `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${currentAccountId}`,
                  {
                    replace: props?.HistoryPopup ? true : false,
                    state: {
                      isViewAll: location.pathname.includes("view_all"),
                    },
                  },
                );
                SetcurrentAccountId("");

                if (
                  props.type === "reimburse_txnViewAll_popup" &&
                  props.flow !== "reimburse_txnViewAll_popup_reject"
                ) {
                  props.closeReimburseTxnDetailsModal();
                }
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        )}

        <div
          className={`bg-primary-bg flex flex-col ${props?.type === "reimburse_txnViewAll_popup" || props?.similarTxnType === "similarTxn" ? "h-full flex-1" : "h-screen"}  `}
          id=" benetxnmain"
        >
          <div className={`transactionHistoryPop_topDiv hidden none `}></div>
          {/* Spacer for navbar / breadcrumb */}
          {/* Spacer for navbar / breadcrumb */}
          <div
            className={`relative z-z-index-overlay ${props?.similarTxnType === "similarTxn" ? "" : "Qmd:min-h-navbar-breadcrumb-height"} ${props?.type === "reimburse_txnViewAll_popup" && "hidden"} ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}`}
          ></div>
          <div
            className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${props?.type === "reimburse_txnViewAll_popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
          >
            <TopNavComponent
              direction={direction}
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              handleBack={() => {
                if (isLabelClicked) {
                  setisLabelClicked(false);
                } else {
                  navigate(GlobalConfiguration?.navigate_back);
                }
              }}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length >
                          GlobalConfiguration?.lengthCheckZero
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        if (
                          labelTransactions?.length >
                          GlobalConfiguration?.lengthCheckZero
                        ) {
                          setLabelTransactions([]);
                        } else {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              isSelectionView={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign labels",
                      btnType: "button",
                      enabledBgColor: labelTransactions?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!labelTransactions.length) return;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: labelTransactions?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !labelTransactions?.length,
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : ""
              }
              BottomSubTextVaraint="primary"
              selectionText={`Transactions selected: ${labelTransactions.length}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      enabledBgColor: `${
                        labelTransactions?.length === Number(selectedValue)
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                      }`,

                      isDisabled:
                        loading ||
                        selectableTransactions?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,

                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (selectableTransactions?.length) {
                          handleSelectAll();
                        }
                      },

                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",

                      icon:
                        !loading &&
                        labelTransactions?.length === Number(selectedValue)
                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,

                      fullWidthRequired: false,

                      hoverOption: `${labelTransactions?.length ? "black" : "white"}`,
                    }
                  : undefined
              }
              isToggleNeeded={true}
              toggleProps={
                !isLabelClicked
                  ? {
                      state: toggleReimTxn,
                      title: toggleReimTxn ? "Grid View" : "List View",
                      isDisabled: false,
                      handleClick: (e) => {
                        handleToggle(!toggleReimTxn);
                      },
                    }
                  : undefined
              }
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: loading,
                isFilterDisabled: loading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search reimbursement transaction",
                filterPlaceholder: "Category specific details",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchUserText(val);
                    },
                    isDropdown: false,
                    isDisabled: false,
                  },

                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: ownerAccId,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("sourceAcc", val);
                      setOwnerAccId(val);
                      if (!val) setAccountNumber("");
                    },
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.owner_account_id
                        ? true
                        : loading
                          ? true
                          : false,
                  },
                  {
                    name: "Reimbursement account",
                    short_name: "Reimb A/c",
                    isMulti: false,
                    value: selectedBeneAccId,
                    displayValue:
                      accountName?.toLowerCase() ||
                      accountNameValue?.toLowerCase(),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("beneAcc", val);
                      setSelectedBeneAccId(val);
                      if (!val) {
                        setAccountName("");
                        setAccountNameValue("");
                      }
                    },
                    setDisplayValue: (val) => {
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: lockedAccount || loading,
                  },
                  {
                    name: "Category",
                    short_name: "Cat",
                    valueType: "string",
                    isMulti: false,
                    value: currentCategory,
                    displayValue: displayCategory,
                    setValue: (val) => {
                      const c =
                        categories.filter((x) => x.id === val)[0]?.name ?? "";
                      setDisplayCategory(c);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("category", val);
                      setCurrentCategory(val);
                      handleSubmit("dispCat", c);
                    },
                    isDropdown: true,
                    isDisabled: props?.categoryName
                      ? true
                      : loading
                        ? true
                        : false,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelSearchText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit(
                        "label",
                        Array.isArray(val) ? val.join(",") : val,
                      );
                      setLabelSearchText(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled:
                      props?.flow === "txnLabelfilterhistory"
                        ? true
                        : loading
                          ? true
                          : false,
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("amount", val);
                      setTxnAmountFilter(val);
                    },
                    displayValue: FormatAmount({ price: txnAmountFilter }),
                    isDropdown: false,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.amount
                        ? true
                        : reimbursementTxnViewAllLoading
                          ? true
                          : false,
                    valueType: "number",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    value: currentStatus,
                    options: filteredStatuses.map((status) => status),
                    dropdownPlaceHolder:
                      currentStatus === "deleted"
                        ? "Discard"
                        : currentStatus === "rejected"
                          ? "Rejected"
                          : "Select status",
                    isDisabled:
                      props?.flow === "reimburse_txnViewAll_popup_reject"
                        ? true
                        : currentDistributionStatus?.length >
                            GlobalConfiguration?.lengthCheckZero
                          ? true
                          : false,
                    statusPop: true,
                    handleChange: (val) => {
                      setAnimateViewAll(false);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("lifecycle", val);
                      setCurrentStatus(val);
                      if (val === "require approval") {
                        setIsPaymentMethod("");
                        setStartDateFilter("");
                        setEndDateFilter("");
                        handleSubmit("paymentmethod", "");
                        handleSubmit("date", "");
                      }
                    },
                  },

                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select type",
                    value: isPaymentMethod,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.payment_method
                        ? true
                        : currentStatus === "require approval"
                          ? true
                          : false,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("paymentmethod", val);
                      handlePaymentMethod(val);
                    },
                    dropdownType: "PaymentMethod",
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisabled:
                      currentStatus === "require approval" ? true : false,
                    startDate: startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration?.intervalMedium,
                        )
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration?.intervalMedium,
                        )
                      : endDateFilter,
                    handleChange: (date) => {
                      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                      setAnimateViewAll(false);
                      handleFilterDateRange(date);
                    },
                  },
                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentDistributionStatus,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      currentStatus?.length >
                      GlobalConfiguration?.lengthCheckZero
                        ? true
                        : false,
                    options: [
                      "distribution created",
                      "awaiting funds",
                      "distribution initiated",
                      "distribution rejected",
                      "distribution complete",
                      "distribution abandoned",
                    ],
                    statusPop: true,
                    handleChange: handleDistributionChange,
                  },
                ],
                isFilterClearAllDisabled: loading || !hasFilterParameters,
                isSearchClearAllDisabled: loading || !hasSearchParameters,

                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: dataLoading,
                setLoading: (e) => {},
                isShowFilter: true,
                isShowSortBy: false,
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        loading ||
                        props.type === "reimburse_txnViewAll_popup" ||
                        props?.similarTxnType === "similarTxn"
                          ? true
                          : false,
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (
                          props.type === "reimburse_txnViewAll_popup" ||
                          props?.typepop === "RejectAllTransactionPopup" ||
                          props?.similarTxnType === "similarTxn"
                        ) {
                          actionRestricted();
                        } else {
                          if (
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          ) {
                            setisLabelClicked((prev) => {
                              if (prev) setLabelTransactions([]);
                              return !prev;
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ALabel,RLabel",
                              },
                            });
                          }
                        }
                      },
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>

          {/* Transactions List / Grid */}
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div
            onScroll={handleScroll}
            ref={scrollContainerRef}
            id={
              props?.type === "reimburse_txnViewAll_popup"
                ? ""
                : "infinityScrollContainerBeneView"
            }
            tabIndex="0"
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "mb-[var(--topnavbar-min-height)] Qsmd:mb-margin-base"
                  : ""
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none" : ""} ${
              props?.typepop === "RejectAllTransactionPopup" ||
              props?.type === "reimburse_txnViewAll_popup" ||
              showInnerSearchBar
                ? `h-full overflow-hidden ${props?.type === "reimburse_txnViewAll_popup" && "overflow-y-auto"} min-h-0`
                : "overflow-y-scroll h-full scroll-py-top_md "
            } flex-1 overflow-x-hidden overflow-y-scroll z-z-index-base relative scroll-py-top_md`}
          >
            {loading ? (
              <div className="loader-container m-auto flex items-center justify-center h-full">
                <Loader />
              </div>
            ) : accumulatedData?.length ? (
              // <div
              //   className={`h-height-full flex-1 relative z-z-index-content overflow-x-hidden scroll-py-top_md`}
              // >
              <div
                onAnimationEnd={() => setAnimateViewAll(false)}
                className={`${animateViewAll ? (!toggleReimTxn ? "animate-slide-prev" : "animate-slide-next") : ""}  ${
                  !toggleReimTxn
                    ? "standard-card-alignment content-start"
                    : "standard-list-view-alignment"
                } gap-x-gap-sm gap-y-gap-md`}
              >
                {accumulatedData.map((transactions) => {
                  const categoryIcon = categoryMapper(
                    transactions?.category_id?.category_id,
                  );
                  return !toggleReimTxn ? (
                    <CardContainer
                      filterRef={scrollContainerRef}
                      hoverHeight={
                        GlobalConfiguration?.reimbursementTxnCardHoverHeight
                      }
                      minHeight={
                        GlobalConfiguration.reimbursementTxnCardMinHeight
                      }
                      key={transactions?.txn_id}
                      isNoCursorRequired={
                        props?.flow === "reimburse_txnViewAll_popup_reject"
                          ? true
                          : false
                      }
                      onClickHandler={(e) => {
                        if (
                          showInnerSearchBar ||
                          props?.flow === "reimburse_txnViewAll_popup_reject"
                        ) {
                          return;
                        } else {
                          if (
                            props.alert === "alertpopup" ||
                            props?.similarTxnType === "similarTxn"
                          ) {
                            actionRestricted();
                          } else if (isLabelClicked) {
                            handleLabelTransactionSelect?.(transactions);
                          } else {
                            handleTransactionClick(e, transactions);
                          }
                        }
                      }}
                      isSelected={
                        Array.isArray(labelTransactions) &&
                        labelTransactions.some(
                          (transaction) =>
                            transaction?.id === transactions?.txn_id,
                        )
                      }
                    >
                      <card-body>
                        {transactions?.amount != null ? (
                          <TextWithIcon
                            type="Amount"
                            isAbbrevation={true}
                            fontWeight="semibold"
                            text={transactions?.amount}
                            subText="Approved amount"
                            textColor="var(--settled)"
                            iconComponentArray={[
                              ...(transactions?.confidential_transaction === "Y"
                                ? [
                                    {
                                      icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                      title: "confidential",
                                      isDisabled: false,
                                    },
                                  ]
                                : []),

                              // Label icon
                              ...(isLabelClicked &&
                              transactions?.distribution_lifecycle_status !==
                                "distribution_complete"
                                ? [
                                    {
                                      icon: labelTransactions.some(
                                        (transaction) =>
                                          transaction?.id ===
                                          transactions?.txn_id,
                                      )
                                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />
                        ) : (
                          <TextWithIcon
                            type="Text"
                            fontWeight="semibold"
                            text="N/A"
                            subText="Approved amount"
                            textColor="var(--text-primary)"
                            iconComponentArray={
                              isLabelClicked &&
                              transactions?.distribution_lifecycle_status !==
                                "distribution_complete"
                                ? [
                                    {
                                      icon: labelTransactions.includes(
                                        transactions?.txn_id,
                                      )
                                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []
                            }
                          />
                        )}

                        <TextWithIcon
                          type={
                            transactions?.requested_amount ? "Amount" : "Text"
                          }
                          fontWeight="semibold"
                          text={transactions?.requested_amount || "N/A"}
                          subText="Requested amount"
                          textColor={
                            transactions?.lifecycle_status === "rejected" ||
                            transactions?.lifecycle_status === "pending" ||
                            transactions?.requested_amount ===
                              transactions?.amount
                              ? "var(--text-primary)"
                              : "var(--queued)"
                          }
                        />

                        <TextWithIcon
                          text={
                            transactions?.beneficiary_account_name
                              ? transactions.beneficiary_account_name
                              : "N/A"
                          }
                          type="Text"
                          subText="Account name"
                          fontWeight="normal"
                          textColor="var(--text-primary)"
                        />

                        <TextWithBank
                          text={
                            currentStatus === "require approval"
                              ? "require approval"
                              : transactions?.lifecycle_status || "N/A"
                          }
                          subText="Approval status"
                          type="Text"
                          src={categoryIcon.url}
                          imgColor={categoryIcon.colour}
                          ifscCode={transactions?.beneficiary_account_ifsc_code}
                          textColor={
                            transactions?.lifecycle_status === "N/A"
                              ? "var(--text-primary)"
                              : getStatusColor(transactions?.lifecycle_status)
                          }
                          textCase="capitalize"
                          fontWeight="semibold"
                        />
                      </card-body>

                      <card-hover>
                        <div className="mx-margin-sm border-t border-primary-bg"></div>
                        <TextWithIcon
                          text={
                            transactions?.distribution_lifecycle_status ===
                            "created"
                              ? "Distribution created"
                              : transactions?.distribution_lifecycle_status ===
                                  "awaiting_funds"
                                ? "Awaiting funds"
                                : transactions?.distribution_lifecycle_status ===
                                    "distribution_initiated"
                                  ? "Distribution initiated"
                                  : transactions?.distribution_lifecycle_status ===
                                      "abandoned"
                                    ? "Distribution abandoned"
                                    : transactions?.distribution_lifecycle_status ===
                                        "rejected"
                                      ? "Distribution rejected"
                                      : transactions?.distribution_lifecycle_status ===
                                          "failed"
                                        ? "Failed"
                                        : transactions?.distribution_lifecycle_status ===
                                            "distribution_complete"
                                          ? "Distribution complete"
                                          : "N/A"
                          }
                          subText="Distribution status"
                          fontWeight="semibold"
                          textColor={
                            transactions?.distribution_lifecycle_status ===
                            "N/A"
                              ? "var(--text-primary)"
                              : getDistributionColor(
                                  transactions?.distribution_lifecycle_status,
                                )
                          }
                        />
                        {/* </div> */}
                        <TextWithIcon
                          text={
                            transactions?.labels?.length
                              ? transactions.labels.join(", ")
                              : "Not assigned"
                          }
                          fontWeight="normal"
                          textColor="var(--text-primary)"
                          iconComponentArray={[
                            {
                              icon: ICONS?.LABEL,
                            },
                          ]}
                        />
                      </card-hover>
                    </CardContainer>
                  ) : (
                    <ListContainer
                      hoverHeight={
                        GlobalConfiguration?.reimbursementTxnListHoverHeight
                      }
                      key={transactions?.txn_id}
                      filterRef={scrollContainerRef}
                      onClickHandler={(e) => {
                        if (showInnerSearchBar) {
                          return;
                        } else {
                          if (
                            props.alert === "alertpopup" ||
                            props?.similarTxnType === "similarTxn"
                          ) {
                            actionRestricted();
                          } else if (isLabelClicked) {
                            handleLabelTransactionSelect?.(transactions);
                          } else {
                            handleTransactionClick(e, transactions);
                          }
                        }
                      }}
                      isSelected={
                        Array.isArray(labelTransactions) &&
                        labelTransactions?.some(
                          (transaction) =>
                            transaction?.id === transactions?.txn_id,
                        )
                      }
                    >
                      <list-body>
                        {/* My code new  */}
                        <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                          <div className={`flex flex-col gap-y-gap-sm w-full`}>
                            <div className="w-full flex gap-x-gap-sm">
                              <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-tr-border-radius-md rounded-br-border-radius-md">
                                <div className="flex gap-x-gap-sm items-center">
                                  <CommonBankLogo
                                    variant="small"
                                    ifsc={
                                      transactions?.beneficiary_account_ifsc_code
                                    }
                                  />
                                  <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                                  <SVGComponent
                                    url={categoryIcon?.url}
                                    color={categoryIcon?.colour}
                                    height={"var(--icon-sm)"}
                                    width={"var(--icon-sm)"}
                                  />
                                </div>
                              </div>
                              <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                                <span>
                                  {"INR " +
                                    Number(transactions.amount)?.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                        maximumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                      },
                                    )}
                                </span>
                              </p>
                              <div className="border-l border-primary-bg"></div>
                              <div className="flex gap-x-gap-sm justify-end items-center">
                                <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                                  {transactions.created_on
                                    ? formatDateViewAll(
                                        transactions.created_on,
                                        false,
                                        false,
                                      )
                                    : "Not given"}
                                </p>

                                {isLabelClicked &&
                                transactions?.distribution_lifecycle_status !==
                                  "distribution_complete" ? (
                                  <SVGComponent
                                    url={
                                      labelTransactions.some(
                                        (transaction) =>
                                          transaction?.id ===
                                          transactions?.txn_id,
                                      )
                                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                    }
                                    height={"var(--icon-sm)"}
                                    width={"var(--icon-sm)"}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>

                            <div className="w-full pl-padding-sm flex justify-between items-center">
                              <p
                                className={`text-font-xs flex-1 text-text-primary truncate font-normal`}
                              >
                                <TickerAnimation
                                  text={
                                    transactions?.beneficiary_account_name
                                      ? transactions.beneficiary_account_name
                                          .toLowerCase()
                                          .replace(/\b\w/g, (char) =>
                                            char.toUpperCase(),
                                          )
                                      : "N/A"
                                  }
                                />
                              </p>
                              <div
                                style={{
                                  display:
                                    transactions?.confidential_transaction ===
                                    "Y"
                                      ? "flex"
                                      : "none",
                                }}
                                className="gap-x-gap-sm ml-margin-sm justify-end"
                              >
                                <SVGComponent
                                  url={ICONS?.CONFIDENTIAL_TRANSACTION}
                                  height={"var(--icon-sm)"}
                                  width={"var(--icon-sm)"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* My code new  */}
                      </list-body>

                      <list-hover>
                        <ListDualText
                          text1={
                            currentStatus === "require approval"
                              ? "require approval"
                              : transactions?.lifecycle_status || "N/A"
                          }
                          subtext1="Approval status"
                          textCase1="capitalize"
                          text1FontWeight="semibold"
                          text1Color={
                            transactions?.lifecycle_status === "N/A"
                              ? "var(--text-primary)"
                              : getStatusColor(transactions?.lifecycle_status)
                          }
                          text2={
                            transactions?.distribution_lifecycle_status ===
                            "created"
                              ? "Distribution created"
                              : transactions?.distribution_lifecycle_status ===
                                  "awaiting_funds"
                                ? "Awaiting funds"
                                : transactions?.distribution_lifecycle_status ===
                                    "distribution_initiated"
                                  ? "Distribution initiated"
                                  : transactions?.distribution_lifecycle_status ===
                                      "abandoned"
                                    ? "Distribution abandoned"
                                    : transactions?.distribution_lifecycle_status ===
                                        "rejected"
                                      ? "Distribution rejected"
                                      : transactions?.distribution_lifecycle_status ===
                                          "failed"
                                        ? "Failed"
                                        : transactions?.distribution_lifecycle_status ===
                                            "distribution_complete"
                                          ? "Distribution complete"
                                          : "N/A"
                          }
                          subtext2="Distribution status"
                          textCase="none"
                          text2FontWeight="semibold"
                          text2Color={
                            transactions?.distribution_lifecycle_status ===
                            "N/A"
                              ? "var(--text-primary)"
                              : getDistributionColor(
                                  transactions?.distribution_lifecycle_status,
                                )
                          }
                        />

                        <ListTextWithIcon
                          type="text"
                          text={
                            transactions?.labels?.length
                              ? transactions.labels.join(", ")
                              : "Not assigned"
                          }
                          iconComponentArray={[
                            {
                              icon: ICONS?.LABEL,
                            },
                          ]}
                        />
                      </list-hover>
                    </ListContainer>
                  );
                })}
                {/* </div> */}
              </div>
            ) : (
              <div
                className={`flex flex-col items-center justify-center m-auto mt-auto h-full ${
                  showInnerSearchBar
                    ? "overflow-y-hidden pointer-events-none"
                    : ""
                }`}
              >
                <div className="flex flex-col gap-gap-sm items-center justify-center">
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  {clearParameterVisibility ? (
                    <div>
                      <PrimaryButton
                        enabledBgColor="var(--primary-nav-act)"
                        btnText="Clear parameters"
                        btnType="button"
                        handleFunction={handleClearParams}
                        enabledTextColor="var(--text-primary)"
                      />
                    </div>
                  ) : null}
                </div>

                {isLabelClicked ? (
                  <div
                    className={`h-navbar-breadcrumb-height mb-margin-xl block Qmd:hidden ${
                      (props?.typepop === "RejectAllTransactionPopup" ||
                        props?.typepop === "transactionHistorypopup") &&
                      "mb-margin-bottom-pop-up"
                    }`}
                  ></div>
                ) : null}
              </div>
            )}
            {/* Transactions List / Grid */}
          </div>
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
            <div
              className={`${loading && "hidden"} rounded-none bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} w-full h-pagination-height ${showInnerSearchBar && `pointer-events-none  `} ${
                props?.typepop === "RejectAllTransactionPopup"
                  ? "h-auto Qmd:h-status_all_height"
                  : "h-pagination-height"
              }`}
            >
              <div
                className={`${
                  showInnerSearchBar &&
                  "opacity-dark-opacity  pointer-events-none h-full"
                }`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={(e) => {}}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReimbursementTransactionsViewAll;
